const NEW_YORK_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});
const NEW_YORK_EXPIRY_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
});

export const getNewYorkDate = (now = new Date()) => {
  const parts = NEW_YORK_DATE_FORMATTER.formatToParts(now);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const isAnnouncementCurrent = (announcement, now = new Date()) => {
  if (announcement.expiresAt) {
    const expiresAt = new Date(announcement.expiresAt).getTime();
    return Number.isFinite(expiresAt) && now.getTime() < expiresAt;
  }
  return !announcement.eventDate || announcement.eventDate >= getNewYorkDate(now);
};

export const getAnnouncementExpiryInput = (announcement) => {
  if (announcement.expiresAt) return announcement.expiresAt.slice(0, 16);
  return announcement.eventDate ? `${announcement.eventDate}T23:59` : '';
};

export const formatAnnouncementExpiry = (announcement) => {
  if (announcement.expiresAt) return `Until ${NEW_YORK_EXPIRY_FORMATTER.format(new Date(announcement.expiresAt))}`;
  if (announcement.eventDate) {
    const [year, month, day] = announcement.eventDate.split('-').map(Number);
    return `Through ${new Date(Date.UTC(year, month - 1, day, 17)).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/New_York' })}`;
  }
  return 'No automatic expiry';
};